import React, { useEffect } from 'react';
import s from './index.less';
import { Tooltip } from '@/components';
import { useIntl } from 'umi';
import ColorPicker from '../ColorPicker';
import { Popover } from 'antd';
import classNames from 'classnames';
interface ColorProps {
  value: string;
  disabled?: boolean;
  onChange: (color: string) => void;
  onClick: () => void;
}

const Color: React.FC<ColorProps> = (props) => {
  const { value, onChange, disabled, onClick } = props;
  const [popOverOpen, setPopOverOpen] = React.useState(false);

  const { formatMessage } = useIntl();
  const onPopoverOpen = (visible: boolean) => {
    setPopOverOpen(visible);
  };

  return (
    <Popover
      trigger="click"
      placement="right"
      overlayClassName="oj7YZbAO5p"
      onOpenChange={onPopoverOpen}
      align={{ offset: [-2] }}
      content={disabled ? '' : <ColorPicker value={value} onChange={onChange}></ColorPicker>}
    >
      {popOverOpen ? (
        <div className={s.color} >
          <div className={s.circle} style={{ backgroundColor: value }}></div>
        </div>
      ) : (
        <Tooltip
          title={formatMessage({ id: 'color' })}
          destroyTooltipOnHide
          placement="right"
          align={{ offset: [-10, 0] }}
          className={s.tooltip}
        >
          <div className={classNames(s.color, disabled ? s.disabled : '')} onClick={onClick}>
            <div className={s.circle} style={{ backgroundColor: value }}></div>
          </div>
        </Tooltip>
      )}
    </Popover>
  );
};

export default Color;
